const STORAGE_KEY = 'replayer.bookingInvitationResume';

export const saveBookingInvitationResume = token => {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, token);
    return true;
  } catch (error) {
    return false;
  }
};

export const getBookingInvitationResume = () => {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY);
  } catch (error) {
    return null;
  }
};

export const clearBookingInvitationResume = () => {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    // The invitation can still be resumed from the email link.
  }
};
